import React, { useEffect, useState } from "react";
import "@/App.css";
import { LanguageProvider } from './context/LanguageContext';
import { ThemeProvider } from 'next-themes';
import { Toaster } from './components/ui/sonner';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import CookieBanner from './components/CookieBanner';
import { X } from 'lucide-react';

function App() {
  const [regionSuggestion, setRegionSuggestion] = useState(null);

  useEffect(() => {
    const checkRegion = async () => {
      try {
        const response = await fetch('https://get.geojs.io/v1/ip/country.json');
        const data = await response.json();

        const hostname = window.location.hostname;
        const isIndonesian = data.country === 'ID';
        const isLocalhost = hostname === 'localhost' || hostname === '127.0.0.1';

        // Show banner if Indonesian visitor on .com, OR if testing locally
        if ((isIndonesian && hostname.endsWith('.com')) || isLocalhost) {
          setRegionSuggestion({
            message: "Mencari situs versi Indonesia? Kunjungi ",
            url: `https://www.arrigo-iot.co.id${window.location.pathname}${window.location.search}`,
            actionText: "www.arrigo-iot.co.id"
          });
        }
      } catch (error) {
        console.error('Error fetching geolocation data:', error);
      }
    };

    checkRegion();
  }, []);

  return (
    <ThemeProvider attribute="class" defaultTheme="light" enableSystem={false}>
      <LanguageProvider>
        <div className="App relative bg-background text-foreground transition-colors duration-300 min-h-screen">
          <Header />

          {regionSuggestion && (
            <div className="bg-red-600 text-white px-4 py-3 flex items-center justify-center text-sm z-40 absolute top-20 left-0 right-0 shadow-md">
              <div className="text-center font-medium">
                {regionSuggestion.message}
                <a href={regionSuggestion.url} className="underline font-bold hover:text-red-200 transition-colors">
                  {regionSuggestion.actionText}
                </a>
              </div>
              <button
                onClick={() => setRegionSuggestion(null)}
                className="text-white hover:text-red-200 transition-colors absolute right-4"
                aria-label="Dismiss"
              >
                <X size={20} />
              </button>
            </div>
          )}

          <Home />
          <CookieBanner />
          <Footer />
          <Toaster />
        </div>
      </LanguageProvider>
    </ThemeProvider>
  );
}

export default App;
